import toast from './toast';

const supportForm = () => {
  const form = document.querySelector('.wpcf7');

  if (form) {
    form.addEventListener(
      'wpcf7mailsent',
      () => {
        const body = document.querySelector('body');
        const toastWrapper = document.createElement('div');
        const response = document.querySelector('.wpcf7-response-output');
        let message = null;

        setTimeout(() => {
          message = response.textContent;
          toastWrapper.innerHTML = `
          <div class="c-toast c-toast--success js-toast">
            <div class="o-flex o-flex--centered-v">
                <div class="o-flex o-flex--centered-v u-margin-right-small">
                  <img src="/wp-content/themes/trade-gov-chisel/dist/assets/images/svg/success-toast.svg" alt="" />
                </div>
                <div class="o-flex o-flex--centered-v u-text--smaller">
                ${message}
                </div>
            </div>
            <div class="c-toast__clear js-toast-remove">
              <img src="/wp-content/themes/trade-gov-chisel/dist/assets/images/svg/close.svg" alt="" />
            </div>
          </div>`;
          body.append(toastWrapper);
          toast();
          body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0;
        }, 100);
      },
      false,
    );
    form.addEventListener(
      'wpcf7submit',
      () => {
        let message = null;
        const response = document.querySelector('.wpcf7-response-output');
        response.classList.add('u-hidden');

        document.querySelectorAll('.c-label__error').forEach(el => {
          el.parentElement.remove();
        });

        const requiredConditions = document.querySelectorAll(
          '.js-checkbox-required',
        );
        requiredConditions.forEach(condition => {
          if (condition.checked) {
            condition.parentNode.classList.remove('has-error');
          } else {
            if (
              !form
                .querySelector('.js-toggle-labels')
                .classList.contains('is-active')
            ) {
              form.querySelector('.js-toggle-labels').click();
            }
            setTimeout(() => {
              message = response.textContent;
              condition.parentNode.classList.add('has-error');
              const errorWrapper = document.createElement('div');
              errorWrapper.innerHTML = `<span class="c-label__error"><img src="/wp-content/themes/trade-gov-chisel/dist/assets/images/svg/alert.svg" />${message}</span>`;
              condition.parentNode.insertBefore(
                errorWrapper,
                condition.parentNode.firstChild,
              );
            }, 100);
          }
        });
      },
      false,
    );
  }
};

export default supportForm;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/supportForm.js